<template>
    <div>
        <e-dialog
                dialogTitle="关联物流单"
                :centerDialogVisible="relateLogisticsOrderVisible"
                @updateVisible="updateVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'600px'"
                :appendToBody="false">
            <TableList
                    style="margin-top: 16px"
                    :table-data="logisticsOrderData"
                    :table-label="tableLabel">
                <template v-slot:choose="slot">
                    <div> <el-radio v-model="ywlOrderCode" :label="slot.scope.row.ywlOrderCode" @change="logisticsOrder(slot.scope.row)"></el-radio></div>
                </template>
            </TableList>

        </e-dialog>
    </div>
</template>

<script>
  import eDialog from "../../../components/common/e-dialog";
  import TableList from "../../../components/common/e-table-list";
  import logisticsApi from "../../../api/logistics";
  export default {
    name: "relatelogisticsOrderDialog",
    props:{
      relateLogisticsOrderVisible:Boolean,
     },
    components:{eDialog,TableList},
    data(){
      return{
        logisticsOrderData:[],
        tableLabel:[
          {label: '', param: '', align: 'center',slot:'choose' ,width:'34'},
          {label: '物流商', param: 'carrierName', align: 'center', },
          {label: "易物流单号", param: "ywlOrderCode", align: 'center', },
        ],
        ywlOrderCode:'',
        logisticsData:{},
      }
    },
    methods:{
      updateVisible(){
        this.$emit('closeDialog');
      },
      resetPopupData(){
        this.$emit('closeDialog');
      },
      logisticsOrder(row){
        this.logisticsData = row;
      },
      submitPopupData(){
        if(!this.ywlOrderCode){
          this.$message.warning('未关联物流单')
          return false;
        }
        this.$emit('chooseLogistics',this.logisticsData);
      },
      async queryLogisticsList(){
        const res = await logisticsApi.queryLogisticsList();
        if (res.success) {
          this.logisticsOrderData = res.data;
        }
      },
    },
    mounted() {
      this.queryLogisticsList();//发货页面 查询物流单
    }
  }
</script>

<style scoped>

</style>